<template>
  <v-card elevation="0" class="mr-5 ml-5 mt-12" loading height="330px">
        <v-card-text>
          <div id="testHtml" ref="testHtml">
            <v-row no-gutters>
              <v-col cols="12" md="12" sm="12" xs="12">
                <div class="hidden" v-show="!$vuetify.breakpoint.mobile || !$vuetify.breakpoint.xs"></div>
                <v-row no-gutters class="text-center mt-3 ml-n2">
                  <v-col class="mb-6">
                    <div>
                      <v-container>
                          <span style="font-family: Sarabun; font-size: 30px;">{{$t("message.pleasewait")}} . . . </span>
                        <v-card-actions></v-card-actions>
                      </v-container>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </div>
        </v-card-text>
  </v-card>
  
  </template>
  <script>
  export default {
    data() {
      return {
        jwt: require('jsonwebtoken'),
        uuidroom: '',
        checkroom: '',
        checkuuid: '',
        meetingid: '',
        meet_id: '',
      }
    },
    mounted() {
      this.decodejwttoken()
    },
    methods: {
      async checkSession() {
        try {
          const { data } = await this.axios.get(
            process.env.VUE_APP_API + '/api/lv1/join/checksession'
          )
          // console.log('checkSession: ', data.data)
          this.Start = data.data.session
          this.uuid = data.data.uid
          this.checkredirect()
          // this.schemeeting()
        } catch (error) {
          console.log('checkSession: ', error)
        }
      },
      checkredirect() {
        if (this.Start === true) {
          this.checkuuid = this.uuid
          this.$router.push(`/backtolobbyHost?uuid=${this.checkuuid}`)
          // console.log('Error checkredirect:')
        } else {
          this.$router.push('/manage')
          console.log('Error checkredirect:')
        }
      },
      async refrestoken(){
        var token = localStorage.getItem('user-token')
        await this.axios.get(process.env.VUE_APP_API + '/api/lv1/auth/refreshtoken', 
        {
            headers: {
              Authorization: "bearer " + localStorage.getItem('user-token'),
            },
          }
        // await this.axios.post(process.env.VUE_APP_API + '/api/v1/authentication/refrestoken', {
        //   headers: {
        //         Authorization: 'bearer ' + token
        //       }
        // }
        ).then(res => {
          // console.log('sssss', res)
          this.checktoken()
        }).catch(err => {
          this.$swal(this.$t("message.Sessiontimeout") , '' , 'warning').then(result => {
            localStorage.clear()
            localStorage.setItem("lang", "th")
            window.open('/', '_self')
          })
        })
      },
      decodejwttoken() {
          if (localStorage.getItem('user-token') !== null) {
            this.refrestoken()
          } else {
              this.$router.push('/joinpage')
          }
        },
        checktoken() {
          var token = localStorage.getItem('user-token')
          const decryptedText = this.CryptoJS.AES.decrypt(
            token,
            process.env.VUE_APP_SECRET_KEY
          )
            .toString(this.CryptoJS.enc.Utf8)
            .replace(/"/g, '')
          var data = this.jwt.decode(decryptedText)
          this.userData = data
          this.checkSession()
        }
      }
    }
  </script>
  <style scoped>
  .v-progress-circular {
  margin: 1rem;
  }
  </style>
  